// import { Col, Row, Table } from "react-bootstrap";
// import {
// 	BulkCheckboxControl,
// 	DatatableWrapper,
// 	Filter,
// 	TableBody,
// 	TableHeader,
// 	TableRow,
// } from "react-bs-datatable";

// import { parse } from "@fortawesome/fontawesome-svg-core";
// import "bootstrap/dist/css/bootstrap.min.css";

// // Then, use it in a component.
// function DataTable(props) {
// 	// var grandtotal = props.grandtotal || 0,
// 	// 	grandmale,
// 	// 	grandfemale = 0;

// 	// console.log("grandtotal", props);
// 	return (
// 		// <DatatableWrapper
// 		// 	body={props.body}
// 		// 	headers={props.headers}
// 		// 	sortProps={{
// 		// 		sortValueObj: {
// 		// 			date: (date) =>
// 		// 				parse(`${date}`, "MMMM dd, yyyy", new Date()).getTime(),
// 		// 		},
// 		// 	}}
// 		// 	paginationOptionsProps={{
// 		// 		initialState: {
// 		// 			rowsPerPage: 10,
// 		// 			options: [5, 10, 15, 20],
// 		// 		},
// 		// 	}}>
// 		// 	<Row className="mb-4">
// 		// 		<Col
// 		// 			xs={12}
// 		// 			lg={4}
// 		// 			className="d-flex flex-col justify-content-end align-items-end">
// 		// 			<Filter />
// 		// 		</Col>
// 		// 		<Col
// 		// 			xs={12}
// 		// 			sm={6}
// 		// 			lg={4}
// 		// 			className="d-flex flex-col justify-content-lg-center align-items-center justify-content-sm-start mb-2 mb-sm-0">
// 		// 			<PaginationOptions alwaysShowPagination />
// 		// 		</Col>
// 		// 		<Col
// 		// 			xs={12}
// 		// 			sm={6}
// 		// 			lg={4}
// 		// 			className="d-flex flex-col justify-content-end align-items-end">
// 		// 			<Pagination alwaysShowPagination paginationRange={3} />
// 		// 		</Col>
// 		// 		<Col xs={12} className="mt-2">
// 		// 			<BulkCheckboxControl />
// 		// 		</Col>
// 		// 	</Row>
// 		// 	<Table>
// 		// 		<TableHeader />
// 		// 		<TableBody />
// 		// 	</Table>
// 		// </DatatableWrapper>
// 		<DatatableWrapper
// 			body={props.body}
// 			headers={props.headers}
// 			initialState={{
// 				sorting: [], // This disables initial sorting
// 			}}
// 			sortProps={{
// 				sortValueObj: {
// 					date: (date) => {
// 						parse(`${date}`, "DD/MM/YY", new Date()).getTime();
// 					},
// 				},
// 			}}
// 			// paginationOptionsProps={{
// 			// 	initialState: {
// 			// 		rowsPerPage: 10,
// 			// 		options: [5, 10, 15, 20, 30],
// 			// 	},
// 			// }}
// 		>
// 			<Row>
// 				<Col
// 					xs={12}
// 					lg={4}
// 					className="d-flex flex-col justify-content-end align-items-end">
// 					<Filter />
// 				</Col>
// 				{/* <Col
// 					xs={12}
// 					sm={6}
// 					lg={4}
// 					className="d-flex flex-col justify-content-lg-center align-items-center justify-content-sm-start mb-2 mb-sm-0">
// 					<PaginationOptions alwaysShowPagination />
// 				</Col>
// 				<Col
// 					xs={12}
// 					sm={6}
// 					lg={4}
// 					className="d-flex flex-col justify-content-end align-items-end">
// 					<Pagination alwaysShowPagination paginationRange={3} />
// 				</Col> */}
// 				<Col xs={12} className="mt-2">
// 					<BulkCheckboxControl />
// 				</Col>
// 			</Row>
// 			<Table bordered striped>
// 				<TableHeader />
// 				<TableBody>
// 					{(rows) =>
// 						rows.length === 0 ? (
// 							// <EmptyTablePlaceholder />
// 							<tr>
// 								<td colSpan={props.headers.length}>
// 									<h3 style={{ textAlign: "center" }}>No Participants</h3>
// 								</td>
// 							</tr>
// 						) : (
// 							<>
// 								{rows.map((rowData, rowIdx) => {
// 									// if (rowIdx === 0) {
// 									// 	grandtotal = 0;
// 									// 	grandfemale = 0;
// 									// 	grandmale = 0;
// 									// }
// 									// grandtotal = grandtotal + Number(rowData.total);
// 									// grandfemale = grandfemale + Number(rowData.female);
// 									// grandmale = grandmale + Number(rowData.male);

// 									return rowData.status === "unknown" ? (
// 										<tr key={rowData.username}>
// 											<td colSpan={props.headers.length}>Row status unknown</td>
// 										</tr>
// 									) : (
// 										<>
// 											<TableRow
// 												key={rowData.username}
// 												rowData={rowData}
// 												rowIdx={rowIdx}
// 												// onRowClick={(row) =>
// 												// 	alert(`Clicked row containing name ${row.name}.`)
// 												// }
// 											/>
// 										</>
// 									);
// 								})}
// 								<tr>
// 									<td
// 										style={{ textAlign: "right", fontWeight: "bold" }}
// 										colSpan={props.headers.length - 1}>
// 										Grand Total
// 									</td>
// 									{/* <td>{grandmale}</td>
// 									<td>{grandfemale}</td> */}
// 									<td style={{ fontWeight: "bold" }}>{props.grandtotal}</td>
// 								</tr>
// 							</>
// 						)
// 					}
// 				</TableBody>
// 			</Table>
// 		</DatatableWrapper>
// 	);
// }

// export default DataTable;

import { useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import {
	BulkCheckboxControl,
	DatatableWrapper,
	Filter,
	TableBody,
	TableHeader,
	TableRow,
} from "react-bs-datatable";
import { parse } from "date-fns";
import PropTypes from "prop-types";
import "bootstrap/dist/css/bootstrap.min.css";

function DataTable({ headers, body, grandtotal = 0 }) {
	const [visibleTotal, setVisibleTotal] = useState(grandtotal);

	// Function to calculate visible total based on filtered rows
	const calculateVisibleTotal = (rows) => {
		let total = 0;
		rows.forEach((row) => {
			const val = Number(row.total_participants ?? row.total ?? 0); // adapt key name
			total += isNaN(val) ? 0 : val;
		});
		setVisibleTotal(total);
	};

	return (
		<DatatableWrapper
			body={body}
			headers={headers}
			initialState={{ sorting: [] }}
			sortProps={{
				sortValueObj: {
					date: (date) => parse(date, "dd/MM/yy", new Date()).getTime(),
				},
			}}>
			<Row className="mb-3">
				<Col
					xs={12}
					lg={4}
					className="d-flex justify-content-end align-items-end">
					<Filter />
				</Col>
				<Col xs={12} className="mt-2">
					<BulkCheckboxControl />
				</Col>
			</Row>

			<Table bordered striped>
				<TableHeader />
				<TableBody>
					{(rows) => {
						// 🔄 Update visible total when rows change
						calculateVisibleTotal(rows);

						return rows.length === 0 ? (
							<tr>
								<td colSpan={headers.length} className="text-center py-3">
									No Participants
								</td>
							</tr>
						) : (
							<>
								{rows.map((rowData, rowIdx) => (
									<TableRow key={rowIdx} rowData={rowData} rowIdx={rowIdx} />
								))}
								<tr>
									<td
										style={{ textAlign: "right", fontWeight: "bold" }}
										colSpan={headers.length - 1}>
										Grand Total
									</td>
									<td style={{ fontWeight: "bold" }}>{visibleTotal}</td>
								</tr>
							</>
						);
					}}
				</TableBody>
			</Table>
		</DatatableWrapper>
	);
}

DataTable.propTypes = {
	headers: PropTypes.array.isRequired,
	body: PropTypes.array.isRequired,
	grandtotal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default DataTable;
